import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SizeGroup } from '../../models/import-size-data.models';
import { ImportSizeDataService } from '../../services/import-size-data.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { createStructSDK } from '@structdk/extension-sdk';

@Component({
  selector: 'app-import-size-groups',
  imports: [FormsModule, NgSelectModule],
  templateUrl: './import-size-groups.component.html',
  styleUrl: './import-size-groups.component.css',
})
export class ImportSizeGroupsComponent implements OnInit {
  constructor(private importSizeDataService: ImportSizeDataService, private cdr: ChangeDetectorRef) {
   
  }

  sizeGroups: SizeGroup[] = [];
  selectedSizeGroup: string = "";
  selectedFile: File | null = null;
  importdata: any = null
  importvalid: boolean = false;
  working: boolean = false;

  ngOnInit(): void {
    this.importSizeDataService.getSizeGroups().subscribe({
      next: (response) => {
        this.sizeGroups = response;

        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('getSizeGroups failed', error);
        this.cdr.detectChanges();
      }
    });
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    } else {
      this.selectedFile = null;
    }
  }

  reset(): void {
    this.selectedFile = null;
    
    this.selectedSizeGroup = "";

    this.importdata = null;
    this.importvalid = false;
  }

  get isValid(): boolean {
      return Boolean(this.selectedFile !== null && this.selectedSizeGroup);
  }

  validate(): void {
    this.working = true;
    var data = new FormData()

    data.append("File", this.selectedFile!);
    data.append("SizeGroupUid", this.selectedSizeGroup);

    this.importSizeDataService.validateSizeGroupImport(data).subscribe({
      next: (response) => {
        this.importdata = response;
        console.log(this.importdata);
        if (this.importdata.InvalidHeaders.length > 0) {
            this.importvalid = false;
        }
        else {
            this.importvalid = true;
        }

        this.working = false;

        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('getSizeGroups failed', error);
        
        this.working = false;
        this.cdr.detectChanges();
      }
    });
}

commit(): void {
    const struct = createStructSDK();

    this.working = true;
          
    var data = new FormData()

    data.append("File", this.selectedFile!);
    data.append("SizeGroupUid", this.selectedSizeGroup);

    this.importSizeDataService.startSizeGroupImport(data).subscribe({
      next: (response) => {

        this.reset();

        struct.actions.showSnackbarMessage({
          message: 'Uploaded successfully!',
          placement: 'top', // 'top' | 'bottom'
          isError: false,
          durationMs: 3000,    // optional
        });
        
        this.working = false;

        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('getSizeGroups failed', error);
         const message =
          error?.error?.message ||
          error?.statusText ||
          'Something went wrong';
        
        struct.actions.showSnackbarMessage({
          message: message,
          placement: 'top', // 'top' | 'bottom'
          isError: true,
          durationMs: 3000,    // optional
        });

        this.working = false;
        this.cdr.detectChanges();
      }
    });
  }
}